module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-6710a5.0da97941.png";